<template>
  <div class="init">
    <div class="">
      <div class="top">
        <div class="header">
            <div class="logo">
            <img
              src="../../static/img/311logos1.png"
              @click="goIndex()"
              style="cursor: pointer;"
              alt=""
            />
            </div>
            <div class="title_header">
              <router-link :to="{ name: 'Home' }">首页</router-link>
              <router-link :to="{ name: 'curriculumCenter' }"
                >课程中心</router-link
              >
              <router-link :to="{ name: 'parentsChannel' }"
                >家长学校</router-link
              >
            </div>
            <div class="block">
                <div class="uimg" @click="toMy">
                  <!-- <el-avatar :size="50" :src="userModule.filePath"></el-avatar> -->
                  <img v-if="userModule.filePath" :src="userModule.filePath" />
                  <img v-else src="./../assets/images/morenT.png">
                </div>
                <div class="peoMes" v-if="userModule.isLogin==true">
                  <h4>你好！</h4>
                  <p style="overflow:hidden; font-size:13px;">{{userModule.nickName?userModule.nickName:userModule.mobile}}</p>
                </div>
                <div class="clear"></div>
                <div class="userSet" v-if="userModule.isLogin==true">
                  <ul>
                    <li><a @click="toMy">用户中心</a></li>
                    <li><a @click="tuichu">退出</a></li>
                  </ul>
                </div>
              </div>
            <div class="iconTips">
              <div @click="toMyShop">
                <el-badge
                  v-if="userModule.isLogin"
                  :value="shoppingCartNum"
                  class="item"
                >
                  <img src="../../static/img/购物车.png" alt=""
                /></el-badge>
                <img v-else src="../../static/img/购物车.png" alt="" />
                <div>我的购物车</div>
              </div>
              <div @click="toMyCurriculum">
                <img src="../../static/img/课程.png" alt="" />
                <div>我的课程</div>
              </div>
            </div>

            <div class="search">
              <input
                type="text"
                size="small"
                v-model="seachNameAndteacher"
                placeholder="请输入课程名称或讲师姓名"
              />
              <div @click="goSou">搜全网</div>
            </div>
        </div>
      </div>
      <!-- <router-view class="mian" @login='login'></router-view> -->
      <router-view
        @goLogin="
          () => {
            loginShow = true;
          }
        "
        @addShopCar="addShopCar"
        class="mian"
      ></router-view>
    </div>
    <Footer></Footer>

    <el-dialog
      :visible.sync="loginShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="guanbi"
      width="450px"
    >
      <div style="height: 330px" v-if="flag">
        <div style="text-align: center">
          <img src="../../static/img/311logos2.png" alt="" />
        </div>
        <div class="login_select marginTop">
          <span
            :class="{ login_select_change: loginSelect == 2 }"
            @click="(loginSelect = 2), (form.tel = ''), (form.password = '')"
            >账号登录</span>
          <span
            :class="{ login_select_change: loginSelect == 1 }"
            @click="(loginSelect = 1), (form.tel = ''), (form.password = '')"
            >短信登录</span>
        </div>
        <div class="marginTop">
          <el-form v-if="loginSelect == 1" ref="form" :model="form">
            <el-form-item>
              <el-input
                v-model="form.tel"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-row type="flex" justify="space-between">
                <el-input v-model="form.password" placeholder="请输入验证码">
                  <template slot="append">
                    <div class="codeType">
                      <span :class="{canCho:canGet1}" v-show="show" @click="getCode">获取验证码</span>
                      <span v-show="!show" class="count">{{ count }} s</span>
                    </div>
                  </template>
                </el-input>
              </el-row>
            </el-form-item>
          </el-form>
          <el-form v-if="loginSelect == 2" ref="form" :model="form">
            <el-form-item>
              <el-input v-model="form.tel" placeholder="请输入卡号/手机号码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.password"
                show-password
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
          </el-form>
          <div style="display: flex; justify-content: space-between;">
              <span class="forget" @click="forgetPwd">忘记密码</span>
              <el-link type="primary" @click="changeBtn">注册新账号</el-link>
          </div>
          <div class="flexCenter marginTop">
            <el-button class="login" @click="loginBt" style="width:410px;" type="primary">登录</el-button>
          </div>
          <!-- <div class="flexCenter marginTop">
            <el-link type="primary" @click="changeBtn">去注册>></el-link>
          </div> -->
        </div>
      </div>
      <div style="height: 460px" v-if="!flag">
        <div style="text-align: center">
          <img src="../../static/img/311logos2.png" alt="" />
        </div>
        <!-- <div class="login_select marginTop">
          <span @click="loginSelect = 1" style="font-size:16px;">注册账号</span>
        </div> -->
        <div class="marginTop">
          <el-form ref="form" :rules="rules" label-position="right"  label-width="80px" :model="registerForm">
            <el-form-item label="手机号码" prop="tel">
              <el-input v-model="registerForm.tel" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="设置密码" required>
              <el-input type="password" v-model="registerForm.psw" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="pswr">
              <el-input type="password" v-model="registerForm.pswr" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="设置角色" required>
              <el-select
              style="width:100%"
                v-model="registerForm.roleId"
                placeholder="请选择角色"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="验   证   码" required>
              <el-row type="flex" justify="space-between">
                <el-input v-model="registerForm.password" placeholder="请输入验证码">
                  <template slot="append" style="background:red;">
                    <div class="codeType">
                      <span :class="{canCho:canGet}" v-show="show" @click="getCode">获取验证码</span>
                      <span v-show="!show" class="count">{{ count }} s</span>
                    </div>
                  </template>
                </el-input>
              </el-row>
            </el-form-item>
            <div style="text-align: right;">
              <el-link type="primary" @click="changeBtn">使用已有账号登录</el-link>
            </div>
          </el-form>
          <div class="flexCenter marginTop">
            <el-button class="login" type="primary" style="width:100%" @click="registerBt">注册</el-button>
          </div>
          <!-- <div class="flexCenter marginTop">
          </div> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" :visible.sync="roleListShow" width="30%">
      <div>
        <p class="role_select">选择身份</p>
        <div style="display: flex; justify-content: center; margin-top: 20px">
          <div
            class="role_select_item"
            v-for="(r, index1) in roleList"
            :key="index1"
          >
            <img width="100" :src="r.roleName" alt="" />
            <span @click="setRole(r.id)" class="role_select_name">{{
              r.roleName
            }}</span>
          </div>
          <!-- <div class="role_select_item">
             <img width="100" src="../../static/img/家长.png" alt="">
            <span class="role_select_name">家长</span>
          </div>
          <div class="role_select_item">
             <img width="100" src="../../static/img/老师.png" alt="">
            <span class="role_select_name">老师</span>
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Footer from "../components/Footer";
import { mapState } from "vuex";
export default {
  components: {
    Footer,
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.psw) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      canGet:false,
      canGet1:false,
      loginShow: false,
      // dialogVisible: true,
      flag: true,
      seachNameAndteacher: "",
      loginSelect: 2,
      Active: 0,
      show: true,
      timer: null,
      count: null,
      registerForm: {
        tel: "",
        psw: "",
        pswr: "",
        password: "",
        roleId: "",
      },
      form: {
        tel: "",
        telCode: "",
        password: "",
      },
      titleList: [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "课程中心",
          url: "/curriculumCenter",
        },
        {
          name: "家长学校",
          url: "/parentsChannel",
        },
      ],
      circleUrl: "",
      hlogin: "",
      shoppingCartNum: 0,
      roleListShow: false,
      roleList: [],
      imageUrl: "",
      rules: {
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        pswr:[
          { required: true, validator: validatePass2, trigger: 'change' }
        ]
      },
    };
  },
  // filters: {
  //   roleImg(v) {
  //     if (v == "教师") {
  //       return "../../static/img/教师.png";
  //     } else if (v == "家长") {
  //       return "../../static/img/家长.png";
  //     } else {
  //       return "../../static/img/学生.png";
  //     }
  //   },
  // },
  watch: {
    "userModule.invalid": {
      handler(v) {
        if (v !== 0 && !this.loginShow && !this.userModule.isLogin) {
          if (this.$router.history.current.fullPath.includes("myShop")) {
            this.$router.push({ name: "Home" });
          }
          if (this.$router.history.current.fullPath.includes("watchCourse")) {
            this.$router.push({ name: "Home" });
          }
          this.loginShow = true;
        }
      },
    },
    "registerForm.tel":{
      handler(v){
        if(v){
          var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
          if(strTemp.test(v)){
            this.canGet = true;
          }else{
            this.canGet = false;
          }
        }else{
          this.canGet = false;
        }
      }
    },
    "form.tel":{
      handler(v){
        if(v){
          var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
          if(strTemp.test(v)){
            this.canGet1 = true;
          }else{
            this.canGet1 = false;
          }
        }else{
          this.canGet1 = false;
        }
      }
    }
  },
  created() {
    // this.hlogin = window.sessionStorage.getItem("haveLogin");
    // if (this.hlogin == "2" || this.hlogin == null || this.hlogin == undefined) {
    //   // this.dialogVisible = true;
    //   // this.$store.commit("setLoginShow", true);
    // } else {
    //   // this.dialogVisible = false;
    //   // this.$store.commit("setLoginShow", false);
    //   this.getUserMessage();
    //   this.$axios.post("/client/shopping/card/list").then((res) => {
    //     this.shoppingCartNum = res.length;
    //   });
    // }
    // this.getBaseMes();
  },
  computed: {
    ...mapState(["userModule"]),
  },
  mounted() {
    this.getBaseMes();
    // this.init();
  },
  methods: {
    // 去搜索
    goSou() {
      // var u = JSON.stringify(this.seachNameAndteacher);
      this.$router.replace({
        path: "/searchPage",
        query: { condition: this.seachNameAndteacher },
      });
    },
    async init() {
      this.getRoles();
      // let a = await this.$axios.post("/client/user/getAuthenticationData");
      await this.getUserMessage();
      this.addShopCar();
    },
    async addShopCar() {
      if (this.userModule.isLogin) {
        let b = await this.$axios.post("/client/shopping/card/list");
        this.shoppingCartNum = b.length;
      } else {
        this.shoppingCartNum = 0;
      }
    },
    async getBaseMes() {
      let a = this.userModule.fileUrl;
      let dizhi = `/common/getUploadInfo`;
      this.$store.commit("saveBase", await this.$axios.post(dizhi));
      let b = this.userModule.fileUrl;
      this.init();
    },
    changeBtn() {
      (this.show = true),
        (this.timer = null),
        (this.count = null),
        (this.registerForm = {
          tel: "",
          psw: "",
          pswr: "",
          password: "",
          roleId: this.roleList[0].id,
        });
      this.form = {
        tel: "",
        telCode: "",
        password: "",
      };
      this.flag = !this.flag;
    },
    // login() {
    //   this.dialogVisible = true
    // },
    goIndex() {
      if (this.$route.path != "/home") {
        this.$router.push({ name: "Home" });
      }
    },
    toMyShop() {
      if (this.userModule.isLogin) {
        this.$router.push({ name: "shoppingCart" });
      } else {
        this.loginShow = true;
      }
    },
    guanbi() {
      // this.$store.commit("setLoginShow", false);
      this.form = {
        tel: "",
        telCode: "",
        password: "",
      };
    },
    toMyCurriculum() {
      if (this.userModule.isLogin) {
        this.$router.push({ name: "myCurriculum" });
      } else {
        this.loginShow = true;
      }
    },
    toMy() {
      if (this.userModule.isLogin) {
        this.$router.push({ name: "basMessage" });
      } else {
        this.loginShow = true;
      }
    },
    // 退出
    tuichu(){
      if (this.userModule.isLogin) {
        let dizhi = `/common/logout`;
        this.$axios.post(dizhi).then((res) => {
          this.$message({
            message: "账号已退出登录！",
            type: "success",
          });
          window.sessionStorage.setItem("haveLogin", "2");
          this.$store.commit("saveUser", {
            isLogin: false,
            clientId: "",
            email: null,
            filePath: "",
            id: "",
            loginName: "",
            mobile: "",
            nickName: null,
            password: "",
            permissions: null,
            roles: [],
            sessionId: "",
            sex: null,
            userName: null,
          });
          this.$router.push({ name: "Index" });
        });
      } else {
        // this.loginShow = true;
        this.$message.warning("您未登录！");
      }
    },
    btnTitle(index, url) {
      if (this.$route.path != url) {
        this.Active = index;
        this.$router.push(url);
      }
    },
    getCode() {
      if (
        this.form.tel.trim().length == 0 &&
        this.registerForm.tel.trim().length == 0
      ) {
        return this.$message.error("请输入手机号");
      } else {
        var reg = /^1\d{10}$/;
        let boolean = "";
        if (this.form.tel) {
          boolean = reg.test(this.form.tel);
        }
        if (this.registerForm.tel) {
          boolean = reg.test(this.registerForm.tel);
        }
        // var yanzhengS = /^1(3|4|5|7|8)\d{9}$/;
        // debugger
        // if(!yanzhengS.test(this.form.tel)){
        //   this.$message.warning("请输正确的手机号");
        //   return;
        // }
        if (!boolean) {
          return this.$message.error("手机号格式不正确");
        } else {
          this.getTelCode();
        }
      }

    },
    // 获取验证码
    getTelCode() {
      let resetType;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;

        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        if (this.flag) {
          this.getLCode();
        } else {
          this.getTCode();
        }
      }
    },
    // 获取注册短信验证码
    getTCode() {
      let dizhi = `/common/registerSendSmsCode`;
      let primary = { loginName: this.registerForm.tel };
      this.$axios.post(dizhi, primary).then((res) => {
        //console.log("注册用户短信返回", res);
        if (res) {
          this.$message({
            message: "短信验证码已经成功发送，请在手机端查收并正确的填写！",
            type: "success",
          });
        }
      });
    },
    // 获取登录短信验证码
    getLCode() {
      let dizhi = `/common/sendSmsCode`;
      let primary = { loginName: this.form.tel };
      this.$axios.post(dizhi, primary).then((res) => {
        //console.log("登录用户短信返回", res);
        if (res) {
          this.$message({
            message: "短信验证码已经成功发送，请在手机端查收并正确的填写！",
            type: "success",
          });
        }
      });
    },
    // 注册按钮
    registerBt() {
      if (!this.registerForm.tel) {
        this.$message.error("请填写手机号！");
        return;
      }
      if (!this.registerForm.psw) {
        this.$message.error("请填写密码！");
        return;
      }
      if(this.registerForm.psw!=this.registerForm.pswr){
        this.$message.error("密码与确认密码不相同！");
        return;
      }

      var res = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
      if (!res.test(this.registerForm.psw)) {
        this.$message.error("请填写6~12位字母加数字！");
        return;
      }

      if (!this.registerForm.password) {
        this.$message.error("请填写验证码！");
        return;
      }
      let dizhi = `/common/register`;
      let primary = {
        mobile: this.registerForm.tel,
        password: this.registerForm.psw,
        code: this.registerForm.password,
        roleId:this.registerForm.roleId
      };
      this.$axios.post(dizhi, primary).then(res=> {
        if(res){
          this.$message({
            message: "注册成功，请返回登录！",
            type: "success",
          });
        }
        // this.roleListShow = true;
        this.loginShow = false;
        this.flag = true;
      });
    },
    // 登录按钮
    loginBt() {
      let dizhi = this.loginSelect == 2 ? `/common/login` : `/common/loginSms`;
      let primary = { loginName: this.form.tel, password: this.form.password };
      this.$axios.post(dizhi, primary).then((res) => {

        if (res) {
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          this.getUserMessage();
          this.getPeoMes();
          this.addShopCar();
        }
      });
    },
    // 获取个人信息
    getPeoMes() {
      let dizhi = `/client/user/getUserInfoById`;
      this.$axios.post(dizhi).then((res) => {
        //console.log("获取个人信息", res);
        this.userMes = res;
        this.userMes.role = sessionStorage.role;
        this.imageUrl = res.baseFile
          ? sessionStorage.fileUrl + res.baseFile.filePath
          : "";
        window.sessionStorage.setItem("userImg", this.imageUrl);
      });
    },
    // 获取用户信息
    async getUserMessage() {
      this.loginShow = false;
      let a = await this.$axios.post("/client/user/getUserInfoById");
      if (a) {
        a.isLogin = true;
        a.filePath = a.baseFile
          ? this.userModule.fileUrl + a.baseFile.filePath
          : "";
        this.$store.commit("saveUser", a);
      } else {
        this.$store.commit("saveUser", {
          isLogin: false,
          clientId: "",
          email: null,
          filePath: "",
          id: "",
          loginName: "",
          mobile: "",
          nickName: null,
          password: "",
          permissions: null,
          roles: [],
          sessionId: "",
          sex: null,
          userName: null,
        });
      }
      this.addShopCar();
    },
    // 忘记密码
    forgetPwd() {
      this.$router.push("/forget");
      // this.$store.commit("setLoginShow", false);
      this.loginShow = false;
    },
    sayHellow() {
      alert("你好！");
    },
    // 获取用户类型
    getRoles() {
      let dizhi = `/common/member/roleList`;
      // let primary = {typeCode:'user_type'};
      this.$axios.post(dizhi).then((res) => {
        //console.log("获取用户类型", res);
        this.roleList = res;
      });
    },
    // 设置用户角色
    setRole(rid) {
      let dizhi = `/client/user/updateUserRole`;
      let primary = { roleId: rid };
      this.$axios.post(dizhi, primary).then((res) => {
        //console.log("设置角色", res);
        this.$message.success("设置角色成功！");
        this.roleListShow = false;
        this.loginShow = false;
      });
    },
    touxianBt() {
      if (window.sessionStorage.getItem("haveLogin") == 1) {
        this.$router.push({ name: "basMessage" });
      } else {
        // this.dialogVisible = true;
        this.$store.commit("setLoginShow", true);
      }
    },
  },
};
</script>


<style scoped>
.marginTop >>> .el-input-group__append{ background: none; padding: 0;}
.marginTop >>> .el-input-group__append span{ background: #f1f1f1; display: block; height: 38px; line-height: 38px; padding: 0 10px; color: #666;}
.marginTop >>> .el-input-group__append .canCho{ background: #409eff; color: #FFF; display: block; height: 38px; line-height: 38px; padding: 0 10px;}

.init {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 100vh; */
  background-color: #f3f5f7;
}
.el-avatar>img{ width: 100%;}
.header {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}

.on {
  color: #16b2fc;
}

.top {
  background-color: #fff;
}

.mian {
  height: auto;
  background-color: #f3f5f7;
  min-height: calc(100vh - 208px);
}

.init >>> .el-dialog__body{ padding: 30px 50px 50px;}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue